import { render, staticRenderFns } from "./SelectDatabase.vue?vue&type=template&id=bd914826&scoped=true"
import script from "./SelectDatabase.vue?vue&type=script&lang=js"
export * from "./SelectDatabase.vue?vue&type=script&lang=js"
import style0 from "./SelectDatabase.vue?vue&type=style&index=0&id=bd914826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd914826",
  null
  
)

export default component.exports